import React from 'react';
import Grid from '../../Grid';
import Typography from '../../Typography';
export function EmptyState(_a) {
    var icon = _a.icon, text = _a.text;
    return (React.createElement(Grid, { container: true, direction: "column", alignItems: "center", justifyContent: "center", spacing: 1 },
        React.createElement(Grid, { item: true }, icon),
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { variant: "body1" }, text))));
}
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map